﻿import React, { useState, useEffect, Fragment } from 'react';
import { FormTextArea } from 'components/form-fields';
import { Tabs } from 'components/navigation';
import PropTypes from 'prop-types';

export function LocationNotesSettings(
    {
        saving = false,
        businessAreaTabs,
        loading,
        notesSettings,
        onBusinessAreaTabsUpdate,
        onNotesUpdate
    }
) {

    const [note, setNote] = useState("");
    const [loadingValue, setLoading] = useState(true);
    const [selectedTab, setSelectedTab] = useState(0);
    const [businessAreaTabsValue, setBusinessAreaTabs] = useState([]);

    useEffect(() => {
        setLoading(loading);
    }, [loading]);


    useEffect(function () {

        if (businessAreaTabs.length === 0 ) {
            return;
        }

        setBusinessAreaTabs(businessAreaTabs);

    }, [businessAreaTabs])

    
    //When a tab is clicked, select that tab and then set the tabs hierarchy to be the current one
    function onTabClick(index) {

        setSelectedTab(index);
        var clonedTabs = [
            ...businessAreaTabsValue
        ];

        clonedTabs = clonedTabs.map(function (t, i) {
            return {
                ...t,
                selected: index === i
            }
        });
        setBusinessAreaTabs(clonedTabs);

        setNote(businessAreaTabs[index].notes);
    }

    //When tabs are set, select the first one in the list
    useEffect(function () {

        if (businessAreaTabsValue.length === 0 || loadingValue) {
            return;
        }

        onTabClick(0);

    }, [businessAreaTabsValue.length, loadingValue])

    function onNoteChange(e) {
        setNote(e.target.value);

        var clonedBusinessAreaTabs = [
            ...businessAreaTabs
        ];
        clonedBusinessAreaTabs[selectedTab].notes = e.target.value;
        onBusinessAreaTabsUpdate(clonedBusinessAreaTabs);


        var clonedNotes = [
            ...notesSettings
        ];
        clonedNotes[selectedTab] = e.target.value;
        onNotesUpdate(clonedNotes);
    }

    return (
        <Fragment>
            <div className="spacer-bottom">
                <Tabs tabs={businessAreaTabsValue} onClick={onTabClick} loading={loadingValue || loading} />
            </div>
            <FormTextArea
                id="location-note"
                headingText="Internal Notes"
                loading={loadingValue}
                value={note}
                onChange={onNoteChange}
                disabled={saving}
                maxLength={255}
            >
            </FormTextArea>
        </Fragment >
    );
}

LocationNotesSettings.propTypes = {
    businessAreaTabs: PropTypes.array.isRequired,
    notesSettings: PropTypes.array.isRequired,
    saving: PropTypes.bool,
    loading: PropTypes.bool.isRequired
};